//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "DepTree",
  components: {},
  props: ["propData"],
  data: function data() {
    return {
      show: false,
      loading: false,
      tree: {
        boxShow: false,
        data: this.propData,
        props: {
          children: "children",
          label: "name"
        },
        backArr: {}
      },
      check: {
        data: []
      }
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    // 显示弹框
    dialogShow: function dialogShow() {
      this.show = true; // this.loading = true;
      // setTimeout(() => {
      //   this.loading = false;
      // }, 500);
    },
    // 选择中
    checkChange: function checkChange(data, checked) {
      if (checked.checkedKeys[0]) {
        this.$refs.tree.setCheckedNodes([]);
        this.$refs.tree.setCheckedNodes([data]);
        this.check.data = data;
      } else {
        this.$refs.tree.setCheckedNodes([]);
        this.check.data = null;
      }
    },
    // 确定选中
    sureFn: function sureFn() {
      this.show = false;
      this.$emit("backFn", this.check.data);
    }
  },
  watch: {},
  filters: {}
};